/* Click color change image product */
jQuery(document).ready(function($) {
  jQuery('.engoj_select_color a').each(function(){
    jQuery(this).on("click",function(){
      $(this).addClass('active x');
      var engoImage = jQuery(this).data('engojvariant-img');
      jQuery(this).parents('.engoj_grid_parent').find('.engoj_find_img img').attr({ src: engoImage }); 
      return false;
    });
  });
});

jQuery(document).ready(function($) {
  "use strict";
  function throttle(func, wait) {
    var timeout = null;
    return function() {
      var context = this, args = arguments;
      if (!timeout) {
        timeout = setTimeout(function() {
          func.apply(context, args);
          timeout = null;
        }, wait);
      }
    };
  }

  
  function jsProdDetails(){
    $('.js_prod_detail').slick({
      dots: true,
      arrows:true,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow:'<button type="button" class="next-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> <g id="Forma_1"> <path fill-rule="evenodd" clip-rule="evenodd" d="M834.107,232.981L618.365,17.218c-9.3-9.624-24.779-9.624-34.405,0 c-9.299,9.303-9.299,24.778,0,34.059l174.447,174.441H182.759c-13.42,0.021-24.086,10.686-24.086,24.108 c0,13.417,10.666,24.436,24.086,24.436h575.648L583.96,448.375c-9.299,9.63-9.299,25.12,0,34.401 c9.626,9.632,25.128,9.632,34.405,0l215.742-215.742C843.733,257.739,843.733,242.263,834.107,232.981z"/> </g> </g> <g id="Forma_1_copy_1_"> </g> </svg></button>',
      prevArrow:'<button type="button" class="prev-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> </g> <g id="Forma_1_copy_1_"> <g id="Forma_1_copy"> <path fill-rule="evenodd" clip-rule="evenodd" d="M811.881,225.728H245.96L417.457,51.275c9.143-9.269,9.143-24.751,0-34.055 c-9.463-9.627-24.679-9.627-33.821,0l-212.1,215.762c-9.462,9.282-9.462,24.765,0,34.054l212.1,215.742 c9.12,9.627,24.358,9.627,33.821,0c9.143-9.276,9.143-24.772,0-34.4L245.96,274.265h565.921c13.192,0,23.68-11.014,23.68-24.434 C835.561,236.411,825.073,225.749,811.881,225.728z"/> </g> </g> </svg></button>',
    });

  }
  
  function jsProdRelate(){
    $('.js_product_related').slick({
      dots: true,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 4,
      slidesToScroll: 2,
      nextArrow:'<button type="button" class="next-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> <g id="Forma_1"> <path fill-rule="evenodd" clip-rule="evenodd" d="M834.107,232.981L618.365,17.218c-9.3-9.624-24.779-9.624-34.405,0 c-9.299,9.303-9.299,24.778,0,34.059l174.447,174.441H182.759c-13.42,0.021-24.086,10.686-24.086,24.108 c0,13.417,10.666,24.436,24.086,24.436h575.648L583.96,448.375c-9.299,9.63-9.299,25.12,0,34.401 c9.626,9.632,25.128,9.632,34.405,0l215.742-215.742C843.733,257.739,843.733,242.263,834.107,232.981z"/> </g> </g> <g id="Forma_1_copy_1_"> </g> </svg></button>',
      prevArrow:'<button type="button" class="prev-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> </g> <g id="Forma_1_copy_1_"> <g id="Forma_1_copy"> <path fill-rule="evenodd" clip-rule="evenodd" d="M811.881,225.728H245.96L417.457,51.275c9.143-9.269,9.143-24.751,0-34.055 c-9.463-9.627-24.679-9.627-33.821,0l-212.1,215.762c-9.462,9.282-9.462,24.765,0,34.054l212.1,215.742 c9.12,9.627,24.358,9.627,33.821,0c9.143-9.276,9.143-24.772,0-34.4L245.96,274.265h565.921c13.192,0,23.68-11.014,23.68-24.434 C835.561,236.411,825.073,225.749,811.881,225.728z"/> </g> </g> </svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots: false, 
            arrows: true
          }
        }
      ]
    });

  }
  
  function jsCollection(){
    $('.js_collection').slick({
      dots: true,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 3,
      slidesToScroll: 2,
      nextArrow:'<button type="button" class="next-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> <g id="Forma_1"> <path fill-rule="evenodd" clip-rule="evenodd" d="M834.107,232.981L618.365,17.218c-9.3-9.624-24.779-9.624-34.405,0 c-9.299,9.303-9.299,24.778,0,34.059l174.447,174.441H182.759c-13.42,0.021-24.086,10.686-24.086,24.108 c0,13.417,10.666,24.436,24.086,24.436h575.648L583.96,448.375c-9.299,9.63-9.299,25.12,0,34.401 c9.626,9.632,25.128,9.632,34.405,0l215.742-215.742C843.733,257.739,843.733,242.263,834.107,232.981z"/> </g> </g> <g id="Forma_1_copy_1_"> </g> </svg></button>',
      prevArrow:'<button type="button" class="prev-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> </g> <g id="Forma_1_copy_1_"> <g id="Forma_1_copy"> <path fill-rule="evenodd" clip-rule="evenodd" d="M811.881,225.728H245.96L417.457,51.275c9.143-9.269,9.143-24.751,0-34.055 c-9.463-9.627-24.679-9.627-33.821,0l-212.1,215.762c-9.462,9.282-9.462,24.765,0,34.054l212.1,215.742 c9.12,9.627,24.358,9.627,33.821,0c9.143-9.276,9.143-24.772,0-34.4L245.96,274.265h565.921c13.192,0,23.68-11.014,23.68-24.434 C835.561,236.411,825.073,225.749,811.881,225.728z"/> </g> </g> </svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots: false, 
            arrows: true
          }
        }
      ]
    });

  }
  
  
   $('.jstitleqs').on( 'click', function() {
    $(this).toggleClass('engoc-toggle-icon');
  });
  
   function slideProductDetail() {
    $('.js_prod_main').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dot: false,
      fade: false,
      infinite: false,
//       prevArrow: '<button type="button" class="slick-brand-prev ti-angle-left"></button>',
//       nextArrow: '<button type="button" class="slick-brand-next ti-angle-right"></button>',
      asNavFor: '.js_prod_sub'
    });
         $('.js_prodcenter').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      fade: false,
      infinite: false
   
    });
     
     
     $('.product-img-box').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       arrows: false,
       dot: false,
       fade: false,
       infinite: false,
       asNavFor: '.box-thumbnail-pr'
     });
     $('.box-thumbnail-pr').slick({
       slidesToShow: 4,
       slidesToScroll: 1,
       arrows: false,
       asNavFor: '.product-img-box',
       dots: false,
       fade: false,
       infinite: false,
       focusOnSelect: true
     });
     
     
    $('.js_prod_sub').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.js_prod_main',
      dots: false,
      arrows: false,
      infinite: false,
      vertical: true,
      verticalSwiping: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            vertical: true,
            infinite: false,
          }
        },
        {
          breakpoint: 768,
          settings: {
            vertical: false,
            infinite: false,
          }
        },
        
        {
          breakpoint: 575,
          settings: {
            vertical: false,
            infinite: false,
          }
        }
      ]
    });
  
   }
  function slideProductDetailBottom() {
    $('.js_prod_main_bot').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dot: false,
      fade: false,
      infinite: false,
//       prevArrow: '<button type="button" class="slick-brand-prev ti-angle-left"></button>',
//       nextArrow: '<button type="button" class="slick-brand-next ti-angle-right"></button>',
//       asNavFor: '.js_prod_sub_bottom'
    });
//     $('.js_prod_sub_bottom').slick({
//       slidesToShow: 2,
//       slidesToScroll: 1,
//       asNavFor: '.js_prod_main_bot',
//       dots: false,
//       arrows: false,
//       infinite: false,
//       focusOnSelect: true,
//       responsive: [
//         {
//           breakpoint: 1200,
//           settings: {

//           }
//         },

//       ]
//     });
  
   }
  
  function sizeGuide(){
    $('.btn_size_guide').on('click',function(){
      $('.content_size_guide').addClass('active');
      $('.js_sticky').removeClass('sticky_content');
      $('.overlay').addClass('active');
    });
    $('.overlay').on('click',function(){
      $('.content_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
    });
    $('.close_size_guide').on('click',function(){
      $('.js_sticky').addClass('sticky_content');
      $('.content_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
    });
  }
  
  function sortLayout() {
      if ($(window).width() < 1300) {
        $('.size_3').addClass('active');
        $('.size_4').removeClass('active');
        $('.size_5').addClass('d-none');
        $('.size_6').addClass('d-none');
      }
      
      if ($(window).width() >= 1300) {
        $('.size_3').removeClass('active');
        $('.size_4').addClass('active');
        $('.size_5').removeClass('d-none');
        $('.size_6').removeClass('d-none');
      }
    
      if ($(window).width() < 768) {
        $('.size_2').addClass('active');
        $('.size_4').removeClass('active');
        $('.size_5').addClass('d-none');
        $('.size_6').addClass('d-none');
        $('.size_4').addClass('d-none');
        $('.size_3').addClass('d-none');
      }
      $(window).resize(function(){
        if ($(window).width() < 1300) {
          $('.size_3').addClass('active');
          $('.size_4').removeClass('active');
          $('.size_5').addClass('d-none');
          $('.size_6').addClass('d-none');
        }

        if ($(window).width() >= 1300) {
          $('.size_3').removeClass('active');
          $('.size_4').addClass('active');
          $('.size_5').removeClass('d-none');
          $('.size_6').removeClass('d-none');
        }

        if ($(window).width() < 768) {
          $('.size_2').addClass('active');
          $('.size_4').removeClass('active');
          $('.size_5').addClass('d-none');
          $('.size_6').addClass('d-none');
          $('.size_4').addClass('d-none');
          $('.size_3').addClass('d-none');
        }
      });
     
      $('.size_6').on('click', function() {
        $('.js_size_prod').removeClass('col-lg-1 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
        $('.js_size_prod').addClass(' col-lg-2');
        $(this).addClass('active');
        $('.size_5').removeClass('active');
        $('.size_4').removeClass('active');
        $('.size_3').removeClass('active');
      });	
	 	
      $('.size_5').on('click', function() {
        $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
        $('.js_size_prod').addClass('col-lg-2dot4');
        $(this).addClass('active');
        $('.size_6').removeClass('active');
        $('.size_4').removeClass('active');
        $('.size_3').removeClass('active');
      });
      $('.size_4').on('click', function() {
        $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
        $('.js_size_prod').addClass('col-md-3');
        $(this).addClass('active');
        $('.size_5').removeClass('active');
        $('.size_6').removeClass('active');
        $('.size_3').removeClass('active');
        $('.size_2').removeClass('active');
      });
      $('.size_3').on('click', function() {
        $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
        $('.js_size_prod').addClass('col-md-4');
        $(this).addClass('active');
        $('.size_5').removeClass('active');
        $('.size_4').removeClass('active');
        $('.size_6').removeClass('active');
        $('.size_2').removeClass('active');
      });
      $('.size_2').on('click', function() {
        $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12 col-12');
        $('.js_size_prod').addClass('col-6');
        $(this).addClass('active');
        $('.size_3').removeClass('active');
        $('.size_4').removeClass('active');
        $('.size_1').removeClass('active');
      });
    
      $('.size_1').on('click', function() {
        $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12 col-6');
        $('.js_size_prod').addClass('col-12');
        $(this).addClass('active');
        $('.size_3').removeClass('active');
        $('.size_4').removeClass('active');
        $('.size_2').removeClass('active');
      });
    	
   	    
    	
    }
  
  function changeProdListGrid(){
    $('.prod_grid').on('click',function(){
      $('.product-grid-view').addClass('active');
      $('.product-list-view').removeClass('active');
      $(this).addClass('active');
      $('.prod_list').removeClass('active');
      $('.prod_per').removeClass('active');

    });
    $('.prod_list').on('click',function(){
      $('.product-grid-view').removeClass('active');
      $('.product-list-view').addClass('active');
      $(this).addClass('active');
      $('.prod_grid').removeClass('active');
      $('.prod_per').addClass('active');
    });
  }
  
  function FilterPushLeft(){
    $('.js_filter_mobile').on('click',function(){
      $('.filter-to-left').toggleClass('active');
      $('.overlay-filter').addClass('active');    
    });

    $('.jsclick_mnfilter').on( 'click', function() {
      $('.filter-to-left').toggleClass('active');
      $('.overlay-filter').addClass('active'); 
      
    });
    
    $('.close_filter').on('click',function(){
      $('.filter-to-left').removeClass('active');
      $('.overlay-filter').removeClass('active'); 
    });
    $('.overlay-filter').on('click',function(){
      $('.filter-to-left').removeClass('active');
      $('.overlay-filter').removeClass('active'); 
    });
    
 
  }
  
  function heighthdSticky(){
    
    $('.detail-info').css({'top':function(){
        return $('.js_height_hd').outerHeight() + 10;
      }})
  }

  function listcollection(){
    $('.js_list_col').slick({
      dots: false,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 7,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          }
        },
        
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
    });

  }
  
  
  // Safe initialization helper
  function safeInit(fn, name) {
    try {
      if (typeof fn === 'function') {
        fn();
      }
    } catch (e) {
      console.error('Error initializing ' + name + ':', e);
    }
  }

  safeInit(jsProdDetails, 'jsProdDetails');
  safeInit(listcollection, 'listcollection');
  safeInit(jsProdRelate, 'jsProdRelate');
  safeInit(slideProductDetail, 'slideProductDetail');
  safeInit(sizeGuide, 'sizeGuide');
  safeInit(slideProductDetailBottom, 'slideProductDetailBottom');
  safeInit(sortLayout, 'sortLayout');
  safeInit(changeProdListGrid, 'changeProdListGrid');
  safeInit(FilterPushLeft, 'FilterPushLeft');
  safeInit(jsCollection, 'jsCollection');
  safeInit(heighthdSticky, 'heighthdSticky');

});

jQuery(document).ready(function($) {
  $('[data-toggle="tooltip"]').tooltip(); 
});



jQuery(document).ready(function($) {
  "use strict";
  function throttle(func, wait) {
    var timeout = null;
    return function() {
      var context = this, args = arguments;
      if (!timeout) {
        timeout = setTimeout(function() {
          func.apply(context, args);
          timeout = null;
        }, wait);
      }
    };
  }
  
   function productv2(){
    $('.slick_product_trending').slick({
      arrows: false,
      infinite: false,
      dots: false ,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            arrows: true,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            arrows: true,
          }
        }
      ]
    });
  }
  
    function Blogv1(){
          $('.js-blog-v1').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
          arrows: false,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right"></i></button>',
          responsive: [
          {
            breakpoint: 1500,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrow: true,
              dots: false,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: true,
              dots: false,
            }
          },
         {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              dots: false,
            }
          },


        ]

          });
        }
            
     function producth3handpicked(){
    $('.slick_product_handpicked').slick({
      arrows: true,
      infinite: false,
      dots: false ,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right"></i></button>',
       responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  }

       function productv4(){
    $('.slick_product_trendingh3').slick({
      arrows: true,
      infinite: false,
      dots: true ,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
    });
  }
     
        function servicev1(){
    $('.slickjs-services-v1').slick({
      dots: false,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 757,
          settings: {
            slidesToShow: 1,
            arrows:true,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
             arrows:true,
          }
        }
      ]
    });

  }
  
    function servicev2(){
    $('.slickjs-services-v2').slick({
      dots: false,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

  }
  
       function slidehome1(){
    $('.slick-side-h1').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3500,
      dots: false,
      arrows: true,
      fade: true,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
    });
  }  
  
    function slidehome4(){
    $('.slick-side-h3').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3500,
      dots: true,
      arrows: false,
      fade: true, 
      responsive: [

        {
          breakpoint: 1200,
          settings: {
            infinite: true,
            dots: true ,
            arrows: false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            dots: true ,
            arrows: false
          }
        },
        {
          breakpoint:600,
          settings: {
            dots: true ,
            arrows: false,
            autoplay: true,
          }
        }
      ]
    });
  }

      


  
  
  

  function brandv1() {
    $('.jsbrand_list_v1').slick({
      dots: false,
      arrows:true,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  }

  function brandv2() {
    $('.jsbrand_list_v2').slick({
      dots: false,
      arrows:true,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1367,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  }



  
   function collectionv2(){
    $('.slickjs-collection-v2').slick({
      dots: false,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            arrows:true,
          }
        },
        {
          breakpoint: 575,
          settings: "unslick"
        }
      ]
    });
     
      $('.slickjs-collection-v2-2').slick({
      dots: false,
      arrows:true,
      infinite: false,
      speed: 300,
      autoplay:true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            arrows:true,
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            arrows:true,
          }
        }
      ]
    });

  }
  



  function jsBlogv3(){
    $('.js-blog-v3').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      arrows: true,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
          }
        },


      ]
        });
        }


  function Blogv2(){
    $('.js-blog-v2').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },


      ]
        });
        }
        
  function slidehome5(){
    $('.slick-side-h5').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3500,
      dots: true,
      arrows: false,
      fade: true, 
      responsive: [

        {
          breakpoint: 1200,
          settings: {
            infinite: true,
            dots: true ,
            arrows: false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            dots: true ,
            arrows: false
          }
        },
        {
          breakpoint:600,
          settings: {
            dots: true ,
            arrows: false,
            autoplay: true,
          }
        }
      ]
    });
  }
        
     

  function slidehome2(){
    $('.slick-side-h2').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3500,
      dots: true,
      arrows: false,
      fade: true, 
      responsive: [

        {
          breakpoint: 1200,
          settings: {
            infinite: true,
            dots: true ,
            arrows: false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            dots: true ,
            arrows: false
          }
        },
        {
          breakpoint:600,
          settings: {
            dots: true ,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3500
          }
        }
      ]
    });
  }


  
  function search(){
    $('.js-search-destop').on('click', function() {
      $('.js-box-search').addClass('active');
      $('.bg_search_box').addClass('active');
      $('body').addClass('activedestop');
    });
    $('.js-drawer-close').on('click', function() {
      $('.js-box-search').removeClass('active');
      $('.bg_search_box').removeClass('active');
      $('body').removeClass('activedestop');
    });
    $('.bg_search_box').on('click', function() {
      $('.js-box-search').removeClass('active');
      $('.bg_search_box').removeClass('active');
      $('body').removeClass('activedestop');
    });
  }
  
  function minicart(){
    $(document).on('click', '.js-call-minicart', function(e) {
      e.preventDefault();
      $('.js-minicart').addClass('active');
      $('.bg-minicart').addClass('active');
      $('.contentbody').addClass('activecart');
      $('body').addClass('cartover');
    });
    $(document).on('click', '.close-mini-cart, .bg-minicart', function() {
      $('.js-minicart').removeClass('active');
      $('.bg-minicart').removeClass('active');
      $('.contentbody').removeClass('activecart');
      $('body').removeClass('cartover');
    });
  }

  function menudestopscroll1() {
    var $nav = $(".jsheader1");
    $nav.removeClass('menu_scroll_v1');

    $(document).scroll(throttle(function() {
      $nav.toggleClass('menu_scroll_v1', $(this).scrollTop() > $nav.height());
    }, 100));
  }  
  
  function menudestopscroll2() {
    var $nav = $(".jsheader2");
    $nav.removeClass('menu_scroll_v2');

    $(document).scroll(throttle(function() {
      $nav.toggleClass('menu_scroll_v2', $(this).scrollTop() > $nav.height());
    }, 100));
  }
  
  function menudestopscroll3() {
    var $nav = $(".jsheader3");
    $nav.removeClass('menu_scroll_v3');

    $(document).scroll(throttle(function() {
      $nav.toggleClass('menu_scroll_v3', $(this).scrollTop() > $nav.height());
    }, 100));
  }
  
  function menudestopscroll4() {
    var $nav = $(".jsheader4");
    $nav.removeClass('menu_scroll_v4');

    $(document).scroll(throttle(function() {
      $nav.toggleClass('menu_scroll_v4', $(this).scrollTop() > $nav.height());
    }, 100));
  }
  
  function menudestopscroll5() {
    var $nav = $(".jsheader5");
    $nav.removeClass('menu_scroll_v5');

    $(document).scroll(throttle(function() {
      $nav.toggleClass('menu_scroll_v5', $(this).scrollTop() > $nav.height());
    }, 100));
  }
  
  function menudestopscroll6() {
    var $nav = $(".jsheader6");
    $nav.removeClass('menu_scroll_v6');

    $(document).scroll(throttle(function() {
      $nav.toggleClass('menu_scroll_v6', $(this).scrollTop() > $nav.height());
    }, 100));
  }
  
  function menuhorizon() {
    
    $('.js-model_menu').on('click', function() {
      $('.js-horizon-menu').addClass('active');
      $('.js-bg-horizon-menu').addClass('active');
      $('body').addClass('cartover');
    });
    
    $('.js_close-menu-horizon').on('click', function() {
      $('.js-horizon-menu').removeClass('active');
      $('.js-bg-horizon-menu').removeClass('active');
      $('body').removeClass('cartover');
    });
    
    $('.js-bg-horizon-menu').on('click', function() {
      $('.js-horizon-menu').removeClass('active');
      $('.js-bg-horizon-menu').removeClass('active');
      $('body').removeClass('cartover');
    });

  }
  
  function jsmenuiconh(){
    $('.js_icon_horizon-menu').on( 'click', function() {
      $(this).toggleClass('active');
    });
  }
  
  function jscalllogindestop(){
    $('.js-call-popup-login').on( 'click', function() {
      $('.js-poup-login-destop').addClass('active');
      $('.js-bg-login-popup').addClass('active');
    });
    $('.js-eveland-close-login').on( 'click', function() {
      $('.js-poup-login-destop').removeClass('active');
      $('.js-bg-login-popup').removeClass('active');
    });
    $('.js-bg-login-popup').on( 'click', function() {
      $('.js-poup-login-destop').removeClass('active');
      $('.js-bg-login-popup').removeClass('active');
    });
  }
  
  function jsBackLogin(){
     $('.jsCreate_account').on('click', function() {
        $('.form_register').show();
        $('.formlogin').hide();    
    });
     $('.tab_navar_right').on('click', function() {
        $('.formlogin').show();
        $('.form_register').hide();    
    });

     $('.jsBack_login').on('click', function() {
        $('.formlogin').show();
        $('.form_register').hide();        
    });
     $('.jsacount_destop').on('click', function() {
        $('.formlogin').show();
        $('.form_register').hide();        
    });
}
  
 

  function jslogindestop(){
    $('.jsCreate_account').on('click', function() {
      $('.form_register-destop').show();
      $('.formlogin-destop').hide();    
    });
    $('.js-call-popup-login').on('click', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();    
    });

    $('.jsBack_login').on('click', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();        
    });
    $('.jsacount_destop').on('click', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();        
    });
  }
  
  
  
  
  function mobilescroll() {
    var $nav = $(".jsmenumobile");
    $nav.removeClass('menu_mobilescroll');

    $(document).scroll(throttle(function() {
        $nav.toggleClass('menu_mobilescroll', $(this).scrollTop() > $nav.height());
    }, 100));
}
  
  function menumobile() {
    $('.menuleft').on('click', function() {
      $(this).toggleClass('active');
      $('.box_contentmenu').toggleClass('active');     
      $('.box_contentmenu_background').toggleClass('active');     
    });
    $('.box_contentmenu_background').on('click', function() {
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
    });
    $('.js-eveland-close').on('click', function() {
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
    });
  }
  
  
  function popup(){
    $(document).on('click', '.jsclosepoup, .modal-overlay', function(e) {
      e.preventDefault();
      $('.jsengo_popup').fadeOut();
      if (typeof jQuery.cookie === 'function') {
        if (!jQuery.cookie('brilliant_pop_newletter') || jQuery.cookie('brilliant_pop_newletter') == null) {
            jQuery.cookie('brilliant_pop_newletter', '1', {expires: 1, path:'/', domain: '' });
        }
      }
    });
  }
  function cookiepopup(){
    if (typeof jQuery.cookie === 'function') {
      if (!jQuery.cookie('brilliant_pop_newletter') || jQuery.cookie('brilliant_pop_newletter') == null) {    
        jQuery(window).load(function() {
          setTimeout(function() { $('.jsengo_popup').show(); }, 300 * 1000);
        });
      } else {
        $('.jsengo_popup').remove();
      }
    }
  }
  
  
  // Scroll to TOP
  function totop(){
  	 var back_to_top = $('#back-to-top');
    if (back_to_top.length) {
        var scrollTrigger = 100, // px
            backToTop = function() {
                var scrollTop = $(window).scrollTop();
                if (scrollTop > scrollTrigger) {
                    back_to_top.addClass('show');
                } else {
                    back_to_top.removeClass('show');
                }
            };
        $(window).on('scroll', throttle(function() {
            backToTop();
        }, 100));
        back_to_top.on('click', function(e) {
            e.preventDefault();
            $('html,body').animate({
                scrollTop: 0
            }, 700);
        });
    }
  }
  
  // Safe initialization helper
  function safeInit(fn, name) {
    try {
      if (typeof fn === 'function') {
        fn();
      }
    } catch (e) {
      console.error('Error initializing ' + name + ':', e);
    }
  }

  safeInit(popup, 'popup');
  safeInit(cookiepopup, 'cookiepopup');
  safeInit(totop, 'totop');
  safeInit(jslogindestop, 'jslogindestop');
  safeInit(jscalllogindestop, 'jscalllogindestop');
  safeInit(menumobile, 'menumobile');
  safeInit(jsBackLogin, 'jsBackLogin');
  safeInit(mobilescroll, 'mobilescroll');
  
  safeInit(jsmenuiconh, 'jsmenuiconh');
  safeInit(menuhorizon, 'menuhorizon');
  
  
  safeInit(menudestopscroll1, 'menudestopscroll1');
  
  
  
  safeInit(menudestopscroll2, 'menudestopscroll2');
  
  
  
  safeInit(menudestopscroll3, 'menudestopscroll3');
  
  
  
  
  
  safeInit(menudestopscroll5, 'menudestopscroll5');
  
  
  
  safeInit(menudestopscroll6, 'menudestopscroll6');
  
  
  safeInit(minicart, 'minicart');
  safeInit(search, 'search');
  safeInit(slidehome5, 'slidehome5');
  safeInit(slidehome4, 'slidehome4');
  safeInit(slidehome1, 'slidehome1');
  safeInit(slidehome2, 'slidehome2');
  safeInit(jsBlogv3, 'jsBlogv3');
  safeInit(brandv1, 'brandv1');
  safeInit(servicev1, 'servicev1');
  safeInit(servicev2, 'servicev2');
  safeInit(collectionv2, 'collectionv2');
  safeInit(producth3handpicked, 'producth3handpicked');
  safeInit(productv4, 'productv4');
  safeInit(brandv2, 'brandv2');
  safeInit(Blogv1, 'Blogv1');
  safeInit(Blogv2, 'Blogv2');
  
  
  safeInit(productv2, 'productv2');

  // --- QUICK SHOP DRAWER IMPLEMENTATION ---
  
  // Inject Drawer container and Overlay if they don't exist
  if ($('#quick-shop-drawer').length === 0) {
    $('body').append(
      '<div id="quick-shop-overlay" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); z-index: 100000; opacity: 0; visibility: hidden; transition: all 0.3s ease;"></div>' +
      '<div id="quick-shop-drawer" style="position: fixed; bottom: 0; left: 0; right: 0; background: #fff; z-index: 100001; border-radius: 20px 20px 0 0; padding: 25px; box-shadow: 0 -10px 40px rgba(0,0,0,0.15); transform: translateY(100%); transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1); max-height: 85vh; overflow-y: auto; direction: ltr; text-align: left; max-width: 500px; margin: 0 auto; font-family: sans-serif;"></div>'
    );
  }

  // --- LOCAL CART STORE MOCK (localStorage) ---
  var mockCart = {
    item_count: 0,
    items: [],
    total_price: 0
  };

  try {
    var stored = localStorage.getItem('local_mock_cart');
    if (stored) {
      mockCart = JSON.parse(stored);
    }
  } catch(e) {}

  function saveMockCart() {
    mockCart.item_count = mockCart.items.reduce(function(sum, item) { return sum + item.quantity; }, 0);
    mockCart.total_price = mockCart.items.reduce(function(sum, item) { return sum + (item.price * item.quantity); }, 0);
    localStorage.setItem('local_mock_cart', JSON.stringify(mockCart));
  }

  function addMockItem(id, quantity, properties, productInfo) {
    var existing = mockCart.items.find(function(item) {
      return item.id === id;
    });

    if (existing) {
      existing.quantity += quantity;
      existing.line_price = existing.price * existing.quantity;
    } else {
      var price = productInfo.price || 25000;
      mockCart.items.push({
        id: id,
        quantity: quantity,
        price: price,
        line_price: price * quantity,
        product_title: productInfo.title || 'Premium Product',
        url: '/products/' + (productInfo.handle || ''),
        image: productInfo.featured_image || '',
        variant_title: productInfo.variant_title || 'Default Title',
        properties: properties || {}
      });
    }
    saveMockCart();
  }

  var currentProduct = null;
  var selectedOptions = {};
  var selectedVariant = null;

  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    return 'Dhs. ' + (cents / 100).toFixed(2);
  }

  $(document).on('click', '.quick-add-btn-bag', function(e) {
    e.preventDefault();
    var $btn = $(this);
    var handle = $btn.attr('data-product-handle');
    if (!handle) return;

    $btn.addClass('loading').css('opacity', '0.6');

    $.getJSON('/products/' + handle + '.js')
      .done(function(product) {
        $btn.removeClass('loading').css('opacity', '1');
        currentProduct = product;
        openQuickShopDrawer(product);
      })
      .fail(function() {
        // Fallback: Dynamically scrape card info to build a mock product so the drawer always opens
        var $card = $btn.closest('.product-item-v1, .product-item-v3, .product');
        var title = $card.find('.title-product a').text().trim() || 'Premium Product';
        var priceText = $card.find('.price').text().trim() || 'AED 250.00';
        var imgUrl = $card.find('.img-product img').first().attr('src') || '';
        var selectedVariantId = $btn.attr('data-variant-id');
        
        // Parse actual color values from card swatches!
        var actualColors = [];
        $card.find('.variant-product a.circle').each(function() {
          var colorVal = $(this).attr('data-color');
          if (colorVal) {
            colorVal = colorVal.trim();
            if (colorVal && actualColors.indexOf(colorVal) === -1) {
              actualColors.push(colorVal);
            }
          }
        });

        // Parse price using robust regex that matches decimal numbers (ignores dots in Dhs. abbreviation)
        var cents = 25000;
        var priceMatch = priceText.match(/\d+(?:\.\d+)?/);
        if (priceMatch) {
          var priceNum = parseFloat(priceMatch[0]);
          if (!isNaN(priceNum)) {
            cents = Math.round(priceNum * 100);
          }
        }
        
        var options = [];
        var variants = [];
        
        if (actualColors.length > 0) {
          options.push({
            name: "Color",
            position: 1,
            values: actualColors
          });
          actualColors.forEach(function(colorVal, index) {
            variants.push({
              id: selectedVariantId ? parseInt(selectedVariantId) + index : 123456789 + index,
              title: colorVal,
              price: cents,
              available: true,
              options: [colorVal]
            });
          });
        } else {
          options.push({
            name: "Title",
            position: 1,
            values: ["Default Title"]
          });
          variants.push({
            id: selectedVariantId ? parseInt(selectedVariantId) : 123456789,
            title: "Default Title",
            price: cents,
            available: true,
            options: ["Default Title"]
          });
        }
        
        var mockProduct = {
          title: title,
          price: cents,
          formatted_price: priceText,
          featured_image: imgUrl,
          handle: handle,
          options: options,
          variants: variants
        };
        
        $btn.removeClass('loading').css('opacity', '1');
        currentProduct = mockProduct;
        openQuickShopDrawer(mockProduct);
      });
  });

  function openQuickShopDrawer(product) {
    selectedOptions = {};
    selectedVariant = product.variants[0];
    
    if (product.options && product.options.length) {
      product.options.forEach(function(opt, index) {
        selectedOptions[opt.name] = product.variants[0].options[index];
      });
    }

    var optionsHtml = '';
    if (product.options && product.options.length && product.options[0].name !== 'Title') {
      product.options.forEach(function(opt, index) {
        optionsHtml += '<div class="quick-shop-option mb-3" data-option-name="' + opt.name + '">';
        optionsHtml += '<label style="font-weight: 600; font-size: 13px; color: #555; display: block; margin-bottom: 8px;">Select ' + opt.name + ':</label>';
        optionsHtml += '<div style="display: flex; flex-wrap: wrap; gap: 8px;">';
        opt.values.forEach(function(val) {
          var isActive = (selectedOptions[opt.name] === val);
          var activeStyle = isActive ? 'background: #000; color: #fff; border-color: #000;' : 'background: #fff; color: #333; border-color: #ddd;';
          optionsHtml += '<button type="button" class="quick-shop-value" data-option-name="' + opt.name + '" data-value="' + val + '" style="border-radius: 4px; padding: 8px 16px; font-size: 13px; font-weight: 500; border: 1px solid; cursor: pointer; transition: all 0.2s ease; margin-right: 8px; margin-bottom: 8px; ' + activeStyle + '">' + val + '</button>';
        });
        optionsHtml += '</div></div>';
      });
    }

    var drawerHtml = 
      '<div style="position: relative; display: flex; gap: 15px; margin-bottom: 20px; align-items: center;">' +
        '<img id="quick-shop-img" src="' + product.featured_image + '" style="width: 80px; height: 80px; object-fit: cover; border-radius: 8px; border: 1px solid rgba(0,0,0,0.06); margin-right: 12px;">' +
        '<div style="padding-right: 25px;">' +
          '<h4 style="margin: 0 0 6px 0; font-size: 16px; font-weight: 600; color: #1a1a1a; line-height: 1.3;">' + product.title + '</h4>' +
          '<span id="quick-shop-price" style="font-size: 15px; font-weight: 600; color: #ddac55;">' + (product.formatted_price || formatMoney(product.price, '{{amount}} AED')) + '</span>' +
        '</div>' +
        '<button type="button" id="quick-shop-close" style="position: absolute; top: -10px; right: -10px; background: none; border: none; font-size: 28px; cursor: pointer; color: #999; line-height: 1;">&times;</button>' +
      '</div>' +
      '<div class="quick-shop-body" style="margin-bottom: 20px;">' +
        optionsHtml +
        '<div class="quick-shop-note mb-4" style="margin-top: 15px;">' +
          '<label style="font-weight: 600; font-size: 13px; color: #555; display: block; margin-bottom: 6px;">Notes / Personalization (الملاحظة):</label>' +
          '<textarea id="quick-shop-note-text" placeholder="Write any notes, names or options..." rows="2" style="width: 100%; border: 1px solid #ddd; border-radius: 6px; padding: 10px; font-size: 13px; outline: none; transition: border-color 0.3s; resize: none;"></textarea>' +
        '</div>' +
      '</div>' +
      '<button type="button" id="quick-shop-submit" style="width: 100%; background: #000; color: #fff; border: none; padding: 14px; border-radius: 8px; font-weight: 600; font-size: 14px; cursor: pointer; transition: all 0.3s ease; display: flex; align-items: center; justify-content: center; gap: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">' +
        '<img src="' + (window.themeAssets ? window.themeAssets.bagIcon : '') + '" style="width: 18px; height: 18px; filter: invert(1); display: block;" alt="Cart">' +
        'إضافة للسلة / Add to Cart' +
      '</button>';

    $('#quick-shop-drawer').html(drawerHtml);

    $('#quick-shop-overlay').css({ 'visibility': 'visible', 'opacity': '1' });
    $('#quick-shop-drawer').css('transform', 'translateY(0)');
    $('body').css('overflow', 'hidden');
  }

  $(document).on('click', '#quick-shop-close, #quick-shop-overlay', function() {
    $('#quick-shop-overlay').css({ 'opacity': '0' });
    setTimeout(function() { $('#quick-shop-overlay').css('visibility', 'hidden'); }, 300);
    $('#quick-shop-drawer').css('transform', 'translateY(100%)');
    $('body').css('overflow', 'auto');
  });

  $(document).on('click', '.quick-shop-value', function() {
    var $btn = $(this);
    var optName = $btn.attr('data-option-name');
    var val = $btn.attr('data-value');
    
    selectedOptions[optName] = val;

    $btn.parent().find('.quick-shop-value').css({
      'background': '#fff', 'color': '#333', 'border-color': '#ddd'
    });
    $btn.css({
      'background': '#000', 'color': '#fff', 'border-color': '#000'
    });

    findMatchingVariant();
  });

  function findMatchingVariant() {
    if (!currentProduct || !currentProduct.variants) return;
    
    var matchedVariant = null;
    currentProduct.variants.forEach(function(variant) {
      var match = true;
      currentProduct.options.forEach(function(opt, index) {
        if (variant.options[index] !== selectedOptions[opt.name]) {
          match = false;
        }
      });
      if (match) matchedVariant = variant;
    });

    if (matchedVariant) {
      selectedVariant = matchedVariant;
      var priceDisplay = currentProduct.formatted_price || formatMoney(matchedVariant.price, '{{amount}} AED');
      $('#quick-shop-price').text(priceDisplay);
      if (matchedVariant.featured_image) {
        $('#quick-shop-img').attr('src', matchedVariant.featured_image.src);
      }
    }
  }

  $(document).on('click', '#quick-shop-submit', function(e) {
    e.preventDefault();
    if (!selectedVariant) return;

    var $submitBtn = $(this);
    var noteText = $('#quick-shop-note-text').val().trim();
    
    $submitBtn.prop('disabled', true).text('Adding to cart...');

    var formData = {
      'items': [{
        'id': selectedVariant.id,
        'quantity': 1,
        'properties': noteText ? { 'Note': noteText } : {}
      }]
    };

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify(formData),
      dataType: 'json',
      contentType: 'application/json'
    })
    .done(function(item) {
      $submitBtn.prop('disabled', false).html('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg> إضافة للسلة / Add to Cart');
      $('#quick-shop-close').click();
      
      if (typeof smartCart !== 'undefined' && typeof smartCart.open === 'function') {
        smartCart.open();
      } else {
        var $cartCount = $('.enj-cartcount');
        if ($cartCount.length) {
          var currentCount = parseInt($cartCount.first().text().trim()) || 0;
          $cartCount.text(currentCount + 1);
        }
      }
    })
    .fail(function() {
      // Local Mock fallback: add to mock database and open smart cart
      var qty = 1;
      var id = selectedVariant ? selectedVariant.id : 123456789;
      var props = noteText ? { 'Note': noteText } : {};
      
      var productInfo = {
        title: currentProduct ? currentProduct.title : 'Premium Product',
        price: currentProduct ? currentProduct.price : 25000,
        featured_image: currentProduct ? currentProduct.featured_image : '',
        handle: currentProduct ? currentProduct.handle : '',
        variant_title: selectedVariant ? selectedVariant.title : 'Default'
      };
      
      addMockItem(id, qty, props, productInfo);
      
      $submitBtn.prop('disabled', false).html('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg> إضافة للسلة / Add to Cart');
      $('#quick-shop-close').click();

      // Open smart cart drawer which will pull local mock cart items dynamically!
      if (typeof smartCart !== 'undefined' && typeof smartCart.open === 'function') {
        smartCart.open();
      } else {
        showLocalSuccessToast();
      }
    });
  });

  function showLocalSuccessToast() {
    $('.local-cart-toast').remove();
    var toast = $('<div class="local-cart-toast" style="position: fixed; bottom: 30px; right: 30px; background: #ddac55; color: #fff; padding: 14px 28px; border-radius: 8px; box-shadow: 0 10px 30px rgba(0,0,0,0.15); z-index: 99999; font-weight: 600; font-size: 14px; transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275); opacity: 0; transform: translateY(30px); display: flex; align-items: center; gap: 10px;"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg> Added to cart successfully (Local test)!</div>');
    $('body').append(toast);
    setTimeout(function() {
      toast.css({ 'opacity': '1', 'transform': 'translateY(0)' });
    }, 50);
    setTimeout(function() {
      toast.css({ 'opacity': '0', 'transform': 'translateY(30px)' });
      setTimeout(function() { toast.remove(); }, 400);
    }, 3000);
  }

});